import { BodySemi, CaptionRegular } from '../../Text';
import { OverflowEllipsis } from 'utils/fragments';
import Stack from '../../Stack';
import styled from 'styled-components';

export const HashtagText = styled(BodySemi)`
    text-transform: lowercase;
`;

// Still used outside the drawers, by the watchlist's dimension banner.
export const DimensionIconTag = styled(Stack).attrs(
    ({ $direction = 'row', $space = '.25em' }) => ({
        $direction,
        $space,
    }),
)`
    font-weight: ${({ theme }) => theme.fontSemiBold};
    text-transform: capitalize;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.gray_3};
`;

export const TableStack = styled(Stack).attrs(
    ({ $space = (theme) => `${theme.space_9}px` }) => ({
        $space,
    }),
)`
    padding: ${({ theme }) => theme.space_9}px;
`;

const ParentEntity = styled(CaptionRegular)`
    max-width: 100%;
    ${OverflowEllipsis};
`;

export const relatedHashtagCell = ({ value: hashtag, row, css = '' }) => {
    return (
        <Stack css={css} $space="-.25rem" $direction="column">
            <ParentEntity as="div">{row?.relatedName}</ParentEntity>
            <BodySemi as="div" css="text-transform: lowercase;">
                {hashtag}
            </BodySemi>
        </Stack>
    );
};
